import { Link } from 'react-router-dom';

interface HeaderProps {
  showAdmin?: boolean;
}

export function Header({ showAdmin = true }: HeaderProps) {
  return (
    <header className="sticky top-0 z-20 border-b border-white/70 bg-white/85 shadow-sm backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          data-testid="catalog-brand"
          className="flex items-center gap-3 text-lg font-bold text-slate-950"
        >
          <span className="grid h-10 w-10 place-items-center rounded-2xl bg-primary-600 text-white shadow-md shadow-primary-600/20">
            C
          </span>
          <span>Clipiti</span>
        </Link>
        {showAdmin && (
          <Link
            to="/admin"
            className="rounded-full px-3 py-2 text-sm font-medium text-slate-500 transition hover:bg-slate-100 hover:text-slate-900"
          >
            ניהול
          </Link>
        )}
      </div>
    </header>
  );
}
